module.exports = __webpack_public_path__ + "img/chrome.4b95fad1.svg";